var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRgbLightSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RGB_Light_Settings",
    "data-name": "RGB Light Settings",
    transform: "translate(-1849 -80)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5788",
    "data-name": "Rectangle 5788",
    width: 50,
    height: 50,
    rx: 8,
    transform: "translate(1849 80)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "RGB_light_Settings-2",
    "data-name": "RGB light Settings"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9397",
    "data-name": "Path 9397",
    d: "M11809.349,1197a.85.85,0,0,1-.848-.851v-3.65h1.7v3.65A.852.852,0,0,1,11809.349,1197Zm-4-1a.852.852,0,0,1-.851-.851V1192.5h1.7v2.648A.852.852,0,0,1,11805.35,1196Zm5.9-3h-8a.751.751,0,0,1-.75-.75v-6a4.749,4.749,0,1,1,9.5,0v6A.751.751,0,0,1,11811.249,1193Zm-4-9.8a3.055,3.055,0,0,0-3.051,3.053v5.049h6.1v-5.049A3.055,3.055,0,0,0,11807.25,1183.2Zm1.619,3.5h-.013a.251.251,0,0,1-.249-.24,1.958,1.958,0,0,0-.373-1.047,1.917,1.917,0,0,0-.967-.5.252.252,0,0,1-.2-.291.249.249,0,0,1,.246-.2.222.222,0,0,1,.044,0,2,2,0,0,1,1.755,2.011A.256.256,0,0,1,11808.869,1186.7Z",
    transform: "translate(-9933.25 -1082.001)",
    fill: "#6b6f72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9395",
    "data-name": "Path 9395",
    d: "M1,0A1,1,0,0,1,2,1V2A1,1,0,0,1,0,2V1A1,1,0,0,1,1,0Z",
    transform: "translate(1873 95)",
    fill: "#0da505"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9396",
    "data-name": "Path 9396",
    d: "M1,0A1,1,0,0,1,2,1V2A1,1,0,0,1,0,2V1A1,1,0,0,1,1,0Z",
    transform: "translate(1879.354 96.5) rotate(45)",
    fill: "#3009f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9394",
    "data-name": "Path 9394",
    d: "M1,0A1,1,0,0,1,2,1V2A1,1,0,1,1,0,2V1A1,1,0,0,1,1,0Z",
    transform: "translate(1870.768 98.621) rotate(135)",
    fill: "#f0171c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRgbLightSettings);
export default __webpack_public_path__ + "static/media/RGBLightSettings.b53893f868e26019aee3fb648dc5a844.svg";
export { ForwardRef as ReactComponent };